import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardSemiBoldTypography} from 'patient-ping-remedy/packages/typography';
import {DatePickerWrapper} from '@common/DatePickerWrapper';

export const Title = styled(StandardSemiBoldTypography)`
  display: block;
  margin-bottom: ${sizes.small};
  font-size: ${fontSize.displaySmall};
  font-weight: bold;
`;

export const StepLink = styled.button`
  padding: 0;
  color: ${colors.blue4};
  background: none;
  border: none;
  cursor: pointer;
`;

export const Content = styled.div`
  padding-top: ${sizes.small};
`;

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${sizes.small};

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.gray2};
  }
`;

export const CustomDatePickerWrapper = styled(DatePickerWrapper)`
  & > div > br,
  & > div > span {
    display: none;
  }
`;
